export const RETRY_FETCH = 'storeBonuses/RETRY_FETCH';
